// TODO: Should we use English instead of the system locale?
const nameSorter = new Intl.Collator(undefined, {usage: 'sort'});

export const compareName = nameSorter.compare.bind(nameSorter);
